import { render, staticRenderFns } from "./myTitle.vue?vue&type=template&id=16c1dcca&scoped=true"
import script from "./myTitle.vue?vue&type=script&lang=js"
export * from "./myTitle.vue?vue&type=script&lang=js"
import style0 from "./myTitle.vue?vue&type=style&index=0&id=16c1dcca&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c1dcca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16c1dcca')) {
      api.createRecord('16c1dcca', component.options)
    } else {
      api.reload('16c1dcca', component.options)
    }
    module.hot.accept("./myTitle.vue?vue&type=template&id=16c1dcca&scoped=true", function () {
      api.rerender('16c1dcca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/industryChainNew/components/myTitle.vue"
export default component.exports